var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrehenCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Drehen Copy__Icn/40px/Drehen-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Drehen Copy__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Drehen Copy__Rectangle"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Drehen Copy__Group-3",
    opacity: 0.200000003,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Drehen Copy__Group-Copy-2",
    transform: "translate(4 2.567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,5.43286133 C23.627417,5.43286133 29,10.8054443 29,17.4328613 C29,24.0602783 23.627417,29.4328613 17,29.4328613 C10.4745433,29.4328613 5.16560725,24.224317 5.00379986,17.7378361 L5,17.4328613 L7,17.4328613 C7,22.9557088 11.4771525,27.4328613 17,27.4328613 C22.5228475,27.4328613 27,22.9557088 27,17.4328613 C27,11.9100138 22.5228475,7.43286133 17,7.43286133 C14.3649404,7.43286133 11.8987215,8.45719881 10.0574813,10.2350772 L12.5825195,10.2355957 L12.5825195,12.2355957 L6.58251953,12.2355957 L6.58251953,6.2355957 L8.58251953,6.2355957 L8.58180609,8.8806252 C10.799531,6.69593729 13.7975412,5.43286133 17,5.43286133 Z",
    transform: "scale(-1 1) rotate(45 .5 -22.335)",
    id: ".._.._src_svg_Icn_40px_Drehen Copy__Combined-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Drehen Copy__Group-2",
    transform: "rotate(180 20 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Drehen Copy__Group-Copy-3",
    transform: "translate(4 2.567)"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Drehen Copy__Group-Copy-2",
    transform: "scale(-1 1) rotate(45 -8.036 -18.799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0.432861328 C18.627417,0.432861328 24,5.80544433 24,12.4328613 C24,19.0602783 18.627417,24.4328613 12,24.4328613 C5.47454326,24.4328613 0.165607248,19.224317 0.00379985776,12.7378361 L-3.55271368e-15,12.4328613 L2,12.4328613 C2,17.9557088 6.4771525,22.4328613 12,22.4328613 C17.5228475,22.4328613 22,17.9557088 22,12.4328613 C22,6.91001383 17.5228475,2.43286133 12,2.43286133 C9.3649404,2.43286133 6.89872152,3.45719881 5.05748133,5.23507722 L7.58251953,5.2355957 L7.58251953,7.2355957 L1.58251953,7.2355957 L1.58251953,1.2355957 L3.58251953,1.2355957 L3.58180609,3.8806252 C5.79953096,1.69593729 8.79754121,0.432861328 12,0.432861328 Z",
    id: ".._.._src_svg_Icn_40px_Drehen Copy__Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrehenCopy);
export default __webpack_public_path__ + "static/media/Drehen Copy.e12148d3f2c832a57f804156fdb7779d.svg";
export { ForwardRef as ReactComponent };